// extracted by mini-css-extract-plugin
export default {"RemoveGuest":"styles_RemoveGuest__65vtQ","RemoveGuest--btn":"styles_RemoveGuest--btn__fdtf2"};